import type { DBConfig } from 'ngx-indexed-db';

export const LOS_INDEXED_DB_NAME = 'los-opportunity-persistence';

export const LOS_INDEXED_DB_CONFIG: DBConfig = {
  name: LOS_INDEXED_DB_NAME,
  version: 1,
  objectStoresMeta: [
    {
      store: 'workflowRuns',
      storeConfig: { keyPath: 'instanceId', autoIncrement: false },
      storeSchema: [
        { name: 'instanceId', keypath: 'instanceId', options: { unique: true } },
        { name: 'workflowKey', keypath: 'workflowKey', options: { unique: false } },
      ],
    },
    {
      store: 'workflowActivePointers',
      storeConfig: { keyPath: 'workflowKey', autoIncrement: false },
      storeSchema: [
        { name: 'workflowKey', keypath: 'workflowKey', options: { unique: true } },
      ],
    },
    {
      store: 'kv',
      storeConfig: { keyPath: 'key', autoIncrement: false },
      storeSchema: [{ name: 'key', keypath: 'key', options: { unique: true } }],
    },
  ],
};

export type LosKvRecord = {
  key: string;
  value: string;
};

export type LosWorkflowRunRecord = {
  instanceId: string;
  workflowKey: string;
  snapshotJson: string;
};

export type LosWorkflowActivePointerRecord = {
  workflowKey: string;
  instanceId: string;
};
